import { Icons } from '@/app/components/ui/Icons'
import { useTranslations } from 'next-intl'
import { FC } from 'react'

const TextLoader = () => <div className="h-14 lg:h-[102px] w-full lg:mb-14" />

const BookingPlaceholder: FC = () => {
	const t = useTranslations('Keywords')
	return (
		<div className="booking__placeholder h-full flex-col max-lg:bg-white max-lg:px-3 max-lg:pt-6 max-lg:pb-3 max-lg:rounded-4xl">
			<TextLoader />
			<div className="flex gap-2 max-lg:w-full justify-center flex-col lg:flex-row">
				<div className="booking__wrapper max-w-[1040px] w-full">
					<div className="booking__inputs w-full max-lg:flex-col">
						{/* Location Input */}
						<div className="max-lg:w-full lg:w-[268px] lg:relative booking__placeholder-input-wrapper booking__placeholder-location-input">
							<Icons.iconPin className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input"
								placeholder="Enter a city or hotel"
								readOnly
							/>
						</div>
						<div className="max-lg:hidden h-[30px] w-[1px] bg-text-200 me-1"></div>

						{/* Check-in Date Input */}
						<div className="booking__placeholder-date-inputs">
							<div className="max-lg:w-full lg:w-[164px] booking__placeholder-input-wrapper">
								<Icons.iconCalendarFrom className="input-icon" />
								<input
									type="text"
									className="booking__placeholder-input"
									placeholder="Check-in"
									readOnly
								/>
							</div>
							<div className="divider-small w-[1px] lg:w-2 bg-text-300 lg:bg-text-400 h-[30px] lg:h-[1px]"></div>

							{/* Check-out Date Input */}
							<div className="max-lg:w-full lg:w-[164px] booking__placeholder-input-wrapper">
								<Icons.iconCalendarTo className="input-icon" />
								<input
									type="text"
									className="booking__placeholder-input"
									placeholder="Check-out"
									readOnly
								/>
							</div>
						</div>
						<div className="max-lg:hidden h-[30px] w-[1px] bg-text-300 mx-1"></div>

						{/* Rooms & Guests Input */}
						<div className="max-lg:w-full lg:w-[290px] booking__placeholder-input-wrapper  booking__placeholder-rooms-input">
							<Icons.iconGuests className="input-icon" />
							<input
								type="text"
								className="booking__placeholder-input"
								placeholder="1 room, 2 guests"
								readOnly
							/>
						</div>

						{/* Search Button */}
						<button
							className="booking__placeholder-button mt-4 lg:mt-0 w-full lg:w-fit flex items-center justify-center gap-2 py-3 px-4 rounded-lg"
							disabled
						>
							<Icons.iconLens className="mr-2" />
							<span>{t('search')}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BookingPlaceholder
